import { render, staticRenderFns } from "./Godfather.vue?vue&type=template&id=52ffb39e"
import script from "./Godfather.vue?vue&type=script&lang=js"
export * from "./Godfather.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports